<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <!-- ngx-datatable-filter -->
                        <fieldset class="form-group">
                            <div class="row align-items-end mt-0 pagination-body">

                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
                                    <div class="btn-group enrollment-list-btn-info" role="group">
                                        <button class="btn enrollment-list-buttons cursor-pointer" type="button"
                                            *ngFor="let stage of stage_list"
                                            [ngClass]="{'btn-primary':activeTab==stage?.name,'btn-outline-primary':activeTab!=stage?.name}"
                                            (click)="activeEmployeeTab(stage?.name)">{{stage.displayname}}</button>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                                    <div class="row-flex">
                                       
                                        <div class="col-flex-2 mb-1 position-relative" placement="top"
                                            ngbTooltip="search by  name,email,phone,pan,account number,empcode">
                                            <input id="ngx-filter-ref"
                                                class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                                                type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                                                (keydown.enter)="filterTask(searchVal)" />
                                            <button class="btn search-btn glow position-absolute"
                                                (click)="filterTask(searchVal)">
                                                <i class="ft-search text-white cursor-pointer"></i>
                                            </button>
                                        </div>
                                        <div class="col-flex-2 mb-1">
                                            <button class="btn btn-primary btn-block users-list-clear glow mb-0"
                                                (click)="resetFilter()">
                                                Reset
                                                <i class="ft-filter text-white cursor-pointer"></i>
                                            </button>
                                        </div>
                                        <div class="col-flex-2 mb-1"
                                            *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                                            <button type="button" (click)="openModalAddTask(addNewModal)"
                                                class="btn btn-primary btn-block users-list-clear glow mb-0"
                                               placement="top" ngbTooltip="Add New">
                                                +
                                            </button>
                                        </div>
                                        <div class="col-flex-2 mb-1"
                                            *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                                            <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0" placement="top"
                                                ngbTooltip="Add New Demo" (click)="openModalAddTask(demoTask_modal)">
                                                + Demo
                                            </button>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                                        [headerHeight]="40" [footerHeight]="40" rowHeight="auto" [limit]="limitRef"
                                        [rows]="rows" [externalPaging]="true" [count]="page.totalPages"
                                        [offset]="page.pageNumber" (page)="pageChangeData($event)">
                                        <ngx-datatable-footer>
                                            <ng-template ngx-datatable-footer-template let-rowCount="rowCount"
                                                let-pageSize="pageSize">
                                                <div class="datatable-footer-inner">
                                                    <div class="total-count">
                                                        <span>Total : {{page.totalPages}}</span>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngx-datatable-footer>

                                    </ngx-datatable>
                                </div>
                                <div class="col-12">
                                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Tickets Guideline</button>
                                  </div>
            
                            </div>
                        </fieldset>
                        
                            <ngx-datatable
                                class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                                [scrollbarH]="true" [columns]="columns">
                                <ngx-datatable-column name="Title" prop="title" [width]="60">
                                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                        <div class="d-flex align-items-center">
                                            <div class="cell-line-height">
                                                <p [ngClass]="{'bg-light-info badge ': row?.label[0]?.displayname =='Assignment'}"
                                                    *ngIf="row?.label[0]?.displayname =='Assignment'">{{row?.label[0]?.displayname}}</p>
                                                <p [ngClass]="{'bg-light-warning badge': row?.label[0]?.displayname =='Events'}"
                                                    *ngIf=" row?.label[0]?.displayname =='Events'">{{row?.label[0]?.displayname}}</p>
                                                <p [ngClass]="{'bg-light-danger badge ': row?.label[0]?.displayname =='Leave'}"
                                                    *ngIf="row?.label[0]?.displayname =='Leave'">{{row?.label[0]?.displayname}}</p>
                                                <p [ngClass]="{'bg-light-primary badge': row?.label[0]?.displayname =='Demo'}"
                                                    *ngIf="row?.label[0]?.displayname =='Demo'">{{row?.label[0]?.displayname}}</p>
                                            
                                                <p class="font-medium-1 line-height-1 mb-2 cursor-pointer"
                                                    (click)="openModalUpdate(adminNotesModal,row?._id,row?.admin_notes,'admin_notes')">{{row?.title}}</p>
                                            <div class="users-box ">
                                                <div class="text-muted font-small-2" *ngFor="let user of row?.to">
                                                    <span class="bg-light-primary badge badge-pill" (click)="openModalEmp(myModal,row?.to,row?._id)">
                                                        {{user?.name}}</span>
                                                </div>
                                            </div>
                                            <div class="users-box ">
                                                <div [matMenuTriggerFor]="task_priority" class="text-muted font-small-2" *ngFor="let priority of row?.priority">
                                                    <span *ngIf="priority?.displayname =='Normal'" class="bg-light-info badge badge-pill">
                                                        {{priority?.displayname}}</span>
                                                    <span *ngIf="priority?.displayname =='Medium'" class="bg-light-warning badge badge-pill">
                                                        {{priority?.displayname}}</span>
                                                    <span *ngIf="priority?.displayname =='High'" class="bg-light-danger badge badge-pill">
                                                        {{priority?.displayname}}</span>
                                                    <span *ngIf="priority?.displayname =='Urgent'" class="bg-light-danger badge badge-pill">
                                                        {{priority?.displayname}}</span>
                                                </div>
                                        
                                                <mat-menu #task_priority="matMenu">
                                        
                                                    <div>
                                                        <div *ngFor="let priority of task_priority_List">
                                                            <button mat-menu-item *ngIf="priority?.displayname !== row?.priority[0]?.displayname"
                                                                (click)="updatePrority(row?._id,priority._id)">
                                                                <span>
                                                                    <span [ngClass]="{'bg-light-info badge badge-pill':priority.displayname == 'Normal'}"
                                                                        placement="top" *ngIf="priority.displayname == 'Normal'">{{priority.displayname}}</span>
                                                                    <span [ngClass]="{'bg-light-warning badge badge-pill':priority.displayname == 'Medium'}"
                                                                        placement="top" *ngIf="priority.displayname == 'Medium'">{{priority.displayname}}</span>
                                                                    <span [ngClass]="{'bg-light-danger badge badge-pill':priority.displayname == 'High'}"
                                                                        placement="top" *ngIf="priority.displayname == 'High'">{{priority.displayname}}</span>
                                                                    <span [ngClass]="{'bg-light-danger badge badge-pill':priority.displayname == 'Urgent'}"
                                                                        placement="top" *ngIf="priority.displayname == 'Urgent'">{{priority.displayname}}</span>
                                                                </span>
                                                            </button>
                                                        </div>
                                        
                                                    </div>
                                                </mat-menu>
                                        
                                            </div>
                                            <div class="users-box">
                                                <p class="schedule-box badge badge-pill">{{row?.is_schedule}}</p>
                                            </div>
                                            </div>
                                            
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Body" prop="body" [width]="140">
                                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                        <div>
                                            <div class="d-flex">
                                                <span class="current-task-box" *ngIf="row?.body" [innerHtml]="row?.body"></span>
                                                <span *ngIf="!row?.body || row?.body =='\n'">
                                                    <i class="ft-plus text-primary cursor-pointer" (click)="openModalUpdate(myModal3,row?._id,row?.body,'body')"
                                                        placement="right" ngbTooltip="add new"></i>
                                                </span>
                                                <span class="ml-2" *ngIf="row?.body"> <i (click)="openModalUpdate(myModal3,row?._id,row?.body,'body')"
                                                        class="ft-edit text-primary cursor-pointer"></i> </span>
                                            </div>
                                        
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Notes" prop="notes" [width]="140">
                                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                        <div>
                                            <div class="d-flex">
                                                <span class="current-task-box" *ngIf="row?.notes" [innerHtml]="row?.notes"></span>
                                                <span *ngIf="!row?.notes || row?.notes =='\n'">
                                                    <i class="ft-plus text-primary cursor-pointer"
                                                        (click)="openModalUpdate(myModal3,row?._id,row?.notes,'notes')" placement="right"
                                                        ngbTooltip="add new"></i>
                                                </span>
                                                <span class="ml-2" *ngIf="row?.notes"> <i (click)="openModalUpdate(myModal3,row?._id,row?.notes,'notes')"
                                                        class="ft-edit text-primary cursor-pointer"></i> </span>
                                            </div>
                                        
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>
                                
                                <ngx-datatable-column name="Actions" [width]="10">
                                    <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        <div class="mb-1"
                                            [ngClass]="{'bg-light-danger': row?.due_date < today_date , 'bg-light-success': row?.due_date > today_date }">
                                            {{row?.due_date | date:'mediumDate'}}</div>
                                        <div>
                                            <i mat-button [matMenuTriggerFor]="menu" class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                                            <i mat-button [matMenuTriggerFor]="menu2" class="ft-settings text-primary cursor-pointer mr-2"></i>
                                        </div>
                                        <div class="users-box">
                                            <p mat-button [matMenuTriggerFor]="statusMenu">
                                
                                                <span [ngClass]="{'badge badge-pill bg-light-success':row?.status[0]?.displayname =='Open'}"
                                                    *ngIf="row?.status[0]?.displayname =='Open'">{{row?.status[0]?.displayname}}</span>
                                                <span [ngClass]="{'badge badge-pill bg-light-warning':row?.status[0]?.displayname =='In-Progress'}"
                                                    *ngIf="row?.status[0]?.displayname =='In-progress'">{{row?.status[0]?.displayname}}</span>
                                                <span [ngClass]="{'badge badge-pill bg-light-danger':row?.status[0]?.displayname =='Closed'}"
                                                    *ngIf="row?.status[0]?.displayname =='Closed'">{{row?.status[0]?.displayname}}</span>
                                                <!-- <span [ngClass]="{'badge badge-pill bg-light-primary':row?.status[0]?.displayname =='Current'}"
                                                    *ngIf="row?.status[0]?.displayname =='Current'">{{row?.status[0]?.displayname}}</span> -->
                                
                                            </p>
                                        </div>
                                
                                        <mat-menu #statusMenu="matMenu">
                                            <div *ngFor="let status of task_status_list">
                                                <button class="btn mb-1" style="width: 100%;"
                                                    [ngClass]="{'bg-light-success':status.displayname =='Open','bg-light-danger':status.displayname =='Closed',
                                                          'bg-light-warning':status.displayname =='In-Progress'}"
                                                    *ngIf="status.displayname !=row?.status[0]?.displayname"
                                                    (click)="updateStatus(row?._id,status?._id)">{{status.displayname}}</button>
                                            </div>
                                        </mat-menu>
                                
                                        <mat-menu #menu="matMenu">
                                            <div>
                                                <button (click)="taskEdit(addNewModal,row?._id)" class="btn mb-1"
                                                    style="width: 100%;">Edit</button>
                                                <button class="btn bg-light-danger" style="width: 100%;"
                                                    (click)="ConfirmDelete(row._id,rowIndex)">Delete</button>
                                            </div>
                                
                                
                                        </mat-menu>
                                        <mat-menu #menu2="matMenu">
                                            <div *ngFor="let status of task_status_list">
                                                <button class="btn" style="width: 100%;" (click)="updateStatus(row?._id,status?._id)"
                                                    *ngIf="activeTab != status?.name">{{status?.displayname}}</button>
                                            </div>
                                        </mat-menu>
                                    </ng-template>
                                </ngx-datatable-column>
                            </ngx-datatable>
                        </div>
                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>

<!-------- Create Task ------------------------- -->

<div>
    <ng-template #addNewModal let-modal>
        <div class="modal-header">
            <h3 *ngIf="!isAddNewTask">Create Task</h3>
            <h3 *ngIf="isAddNewTask">Update Task</h3>
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="modal-body taskboard-modal">
                <form [formGroup]="myForm">
                    <div class="container">
                        <div class="d-flex icons-list">
                            <div class="dropdown mr-2">
                                <i class="fa-solid fa-user-tie fa-xl cursor-pointer"
                                    *ngIf="task_for_selected =='employee'" placement="top"
                                    [ngClass]="{'active-icon': task_for_selected =='employee' }"
                                    [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                                    (click)="isDropdownOpen = !isDropdownOpen"></i>
                                <i class="fa-solid fa-user-graduate fa-xl cursor-pointer"
                                    *ngIf="task_for_selected =='student'" placement="top"
                                    [ngClass]="{'active-icon': task_for_selected =='student' }"
                                    [ngbTooltip]="task_for_selected" id="dropdownMenuButton" data-toggle="dropdown"
                                    (click)="isDropdownOpen = !isDropdownOpen"></i>
                                <div class="dropdown-menu" [class.show]="isDropdownOpen"
                                    aria-labelledby="dropdownMenuButton">
                                    <span class="dropdown-item"
                                        (click)="toggleActiveStudent('student'); isDropdownOpen = false">
                                        <span class="active-tab cursor-pointer">Student</span>
                                    </span>
                                    <span class="dropdown-item"
                                        (click)="toggleActiveStudent('emp'); isDropdownOpen = false">
                                        <span class="active-tab cursor-pointer">Employee</span>
                                    </span>
                                </div>
                            </div>
                            <div class="dropdown mr-1">
                                <i class="fa-solid fa-user fa-xl cursor-pointer"
                                    [ngClass]="{'active-icon': isStudentList}" placement="top" ngbTooltip="individual"
                                    id="dropdownMenuButton2" data-toggle="dropdown"
                                    *ngIf="isStudentList && !isBatchList && isStudent && !isEmployee"
                                    (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                                <i class="fas fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isBatchList}"
                                    placement="top" ngbTooltip="batch" id="dropdownMenuButton2" data-toggle="dropdown"
                                    *ngIf="isBatchList && !isStudentList && isStudent && !isEmployee"
                                    (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" *ngIf="isStudent"
                                    [class.show]="isDropdownOpen_student">
                                    <a class="dropdown-item" *ngIf="!isStudentList"
                                        (click)="toggleActive('student-ind'); isDropdownOpen_student = false">Individual</a>
                                    <a class="dropdown-item" *ngIf="!isBatchList"
                                        (click)="toggleActive('student-batch') ; isDropdownOpen_student = false">Batch</a>
                                </div>
                            </div>
                            <div class="dropdown mr-2">
                                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isEmpList}"
                                    placement="top" ngbTooltip="individual" id="dropdownMenuButton3"
                                    data-toggle="dropdown"
                                    *ngIf="isEmpList && !isTeamList && !isStudentList && !isStudent && isEmployee"
                                    (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                                <i class="fa-solid fa-users fa-xl cursor-pointer"
                                    [ngClass]="{'active-icon': isTeamList}" placement="top" ngbTooltip="team"
                                    id="dropdownMenuButton3" data-toggle="dropdown"
                                    *ngIf="isTeamList && !isEmpList && !isStudentList && !isStudent && isEmployee"
                                    (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3" *ngIf="isEmployee"
                                    [class.show]="isDropdownOpen_employee">
                                    <a class="dropdown-item" *ngIf="!isEmpList"
                                        (click)="toggleActive('emp-ind')">Individual</a>
                                    <a class="dropdown-item" *ngIf="!isTeamList"
                                        (click)="toggleActive('emp-team')">Team</a>
                                </div>
                            </div>
                            <div class="dropdown mr-2">
                                <span class="icon mr-2 mb-2 cursor-pointer"
                                    [ngClass]="{'active-icon': isScheduleList || selectedSchedule}"
                                    (click)="isScheduleList = !isScheduleList" placement="top" ngbTooltip="schedule"
                                    id="scheduleList" data-toggle="dropdown"><i
                                        class="fa-solid fa-calendar-days fa-xl"></i></span>
                                <div class="dropdown-menu hide-scroll" aria-labelledby="scheduleList">
                                    <a class="dropdown-item" *ngFor="let item of scheduleList"
                                        [class.active]="item.id === selectedSchedule">
                                        <span (click)="getChangeScheduleId(item.id)">{{item.name}}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="dropdown">
                                <span class="mr-2 mb-2 cursor-pointer"
                                    [ngClass]="{'active-icon': isPriorityList || selected_task_priority}"
                                    (click)="isPriorityList = !isPriorityList" placement="top" ngbTooltip="priority"
                                    id="priorityList" data-toggle="dropdown"><i
                                        class="fa-solid fa-layer-group fa-xl"></i></span>
                                <div class="dropdown-menu" aria-labelledby="priorityList">
                                    <a class="dropdown-item" *ngFor="let item of task_priority_List"
                                        [class.active]="item._id === selected_task_priority">
                                        <span (click)="getChangeTaskPriority(item._id)">{{item.displayname}}</span>
                                    </a>
                                </div>
                            </div>
                            <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': selectedType}"
                                (click)="isType = !isType" placement="top" ngbTooltip="Type"><i
                                    class="ft-grid fa-xl"></i></span>
                            <div class="dropdown">
                                <span class="mr-2 mb-2 cursor-pointer"
                                    [ngClass]="{'active-icon': isTaskLabel || selectedTaskLabel}"
                                    (click)="isTaskLabel = !isTaskLabel" placement="top" ngbTooltip="task label"
                                    id="task_labelList" data-toggle="dropdown"><i class="ft-tag fa-xl"></i></span>
                                <div class="dropdown-menu task-label-box" aria-labelledby="task_labelList">
                                    <a class="dropdown-item" *ngFor="let item of taskLabelList"
                                        [class.active]="item._id === selectedTaskLabel">
                                        <span (click)="getChangeTaskLabelId(item._id)">{{item.displayname}}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="dropdown">
                                <span class="mr-2 mb-2 cursor-pointer"
                                    [ngClass]="{'active-icon-danger': isMandatory || selectedMandatory}"
                                    (click)="isMandatory = !isMandatory" placement="top" ngbTooltip="mandatory"
                                    id="mandatoryList" data-toggle="dropdown"><i
                                        class="ft-alert-circle fa-xl"></i></span>
                                <div class="dropdown-menu" aria-labelledby="mandatoryList">
                                    <a class="dropdown-item" *ngFor="let item of mandatoryList"
                                        [class.active]="item.id === selectedMandatory">
                                        <span (click)="getChangeMandatoryId(item.id)">{{item.name}}</span>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isEmpList || isTeamList ">
                            <ng-select *ngIf="!isTeam_selected_list" [items]="empList" bindLabel="name" bindValue="_id"
                                placeholder="Select Employee" [(ngModel)]="selectedEmp" [multiple]="true"
                                [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                                (open)="onDropdownOpenEmp($event)" (close)="onDropdownCloseEmp($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionEmp()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}" (change)="toggleSelectionEmp(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <ng-select *ngIf="isTeam_selected_list" [items]="team_selected_list" bindLabel="name"
                                bindValue="_id" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="team_selected_list_data" [ngModelOptions]="{ standalone: true }">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeamList ">
                            <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id"
                                placeholder="Select Team" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="selectTeam" [ngModelOptions]="{ standalone: true }"
                                (open)="onDropdownOpenTeam($event)" (close)="onDropdownCloseTeam($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionTeam()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}" (change)="toggleSelectionTeam(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </fieldset>
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeam_selected_list">
            <ng-select *ngIf="isTeam_selected_list"
              [items]="team_selected_list"
              bindLabel="name"
              bindValue="_id"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="team_selected_list_data"
              [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
          </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isStudentList || isBatchList && !isEmployee">
                            <ng-select *ngIf="!isBatch_selected_list" [items]="studentList" bindLabel="name"
                                bindValue="id" placeholder="Select Student" [(ngModel)]="selectedStudent"
                                [multiple]="true" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                                (open)="onDropdownOpenStudent($event)" (close)="onDropdownCloseStudent($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionStudent()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}"
                                            (change)="toggleSelectionStudent(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items">
                                    <div class="selected-items">
                                        <ng-container *ngFor="let item of items; let i = index">
                                            <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                                        </ng-container>
                                        <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <ng-select *ngIf="isBatch_selected_list" [items]="batch_selected_list" bindLabel="name"
                                bindValue="_id" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="batch_selected_list_data" [ngModelOptions]="{ standalone: true }">
                            </ng-select>

                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatchList && !isEmployee">
                            <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                                [(ngModel)]="selectedBatch" [multiple]="true" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenBatch($event)"
                                (close)="onDropdownCloseBatch($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionBatch()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}" (change)="toggleSelectionBatch(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>

                        </fieldset>
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatch_selected_list">
          <ng-select
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
        </fieldset> -->
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isScheduleList">
          <ng-select
                [items]="scheduleList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeScheduleId($event)"
              >
          </ng-select>
          
        </fieldset> -->
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isPriorityList">
          <ng-select
            [items]="task_priority_List"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Priority"
            [(ngModel)]="selected_task_priority"
            [ngModelOptions]="{ standalone: true }"
            (change)="getChangeTaskPriority($event)"
          >
          </ng-select>
          
        </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isType">
                            <ng-select [items]="typeList" bindLabel="name" bindValue="id" placeholder="Select Type"
                                [(ngModel)]="selectedType" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (change)="getChangeTypeId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isProjectList && !isCheckList && !isLeadType">
                            <ng-select [items]="project_list" bindLabel="name" bindValue="_id"
                                placeholder="Select Project" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="select_project" [ngModelOptions]="{ standalone: true }"
                                (change)="getProjectId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isCheckList && !isProjectList && !isLeadType">
                            <ng-select [items]="check_list" bindLabel="name" bindValue="_id" placeholder="Select check"
                                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_checklist"
                                [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isLeadType && !isCheckList && !isProjectList">
                            <ng-select [items]="leads_type" bindLabel="name" bindValue="id" placeholder="Select Lead"
                                [(ngModel)]="select_leadType" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (change)="getLeadTypeId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isTrainingLead && !isOutsourceLead && !isCheckList && !isProjectList">
                            <ng-select [items]="training_list" bindLabel="title" bindValue="_id"
                                placeholder="Select Training" [(ngModel)]="select_training_lead" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (change)="getTrainingLeadId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isOutsourceLead && !isTrainingLead && !isCheckList && !isProjectList">
                            <ng-select [items]="outsource_list" bindLabel="leads.title" bindValue="_id"
                                placeholder="Select Outsource" [(ngModel)]="select_outsource_lead"
                                [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                                (change)="getOutsourceLeadId($event)">
                            </ng-select>
                        </fieldset>
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTaskLabel">
          <ng-select
                [items]="taskLabelList"
                bindLabel="displayname"
                bindValue="_id"
                placeholder="Select TaskLabel"
                [(ngModel)]="selectedTaskLabel"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTaskLabelId($event)"
              >
          </ng-select>
          
        </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left">
                            <div class="form-control-position">
                                <i class="ft-edit-2"></i>
                            </div>
                            <input type="text" formControlName="title" [(ngModel)]="task_model.title" class="form-control" id="todoTitle"
                                placeholder="Title" (keydown.enter)="$event.preventDefault()" required #todoTitle>
                            <div class="form-control-position control-position-right">
                                <i class="ft-edit-2"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left">
                            <!-- <div class="form-control-position">
                                <i class="ft-message-square"></i>
                            </div>
                            <textarea formControlName="body" class="form-control" placeholder="body">
                                <div class="form-control-position control-position-right">
                                    <i class="ft-message-square"></i>
                                </div>
                             </textarea> -->
                            <label>Body</label>
                            <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.body,'body')" [(ngModel)]="task_model.body"
                                [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
                            </quill-editor>
                        </fieldset>
                        <!-- <fieldset *ngIf="isMandatory">
              <ng-select
              [items]="mandatoryList"
              bindLabel="name"
              bindValue="id"
              placeholder="Select Mandatory"
              [(ngModel)]="selectedMandatory"
              [closeOnSelect]="false"
              [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>
            </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left mt-2">
                            <div class="form-control-position">
                                <i class="fa-regular fa-calendar-days"></i>
                            </div>
                            <input *ngIf="!task_model.due_date" type="date" formControlName="due_date" [(ngModel)]="current_date"
                                class="form-control">
                            <input *ngIf="task_model.due_date" type="date" formControlName="due_date" [(ngModel)]="task_model.due_date"
                                class="form-control">
                            <div class="form-control-position control-position-right">
                                <i class="fa-regular fa-calendar-days"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left mt-2">
                            <div class="form-control-position">
                                <i class="ft-clock"></i>
                            </div>
                            <input *ngIf="!task_model.working_hours" type="text" formControlName="time" [(ngModel)]="time"
                                class="form-control">
                            <input *ngIf="task_model.working_hours" type="text" formControlName="time"  [(ngModel)]="task_model.working_hours" class="form-control">
                            <div class="form-control-position control-position-right">
                                <i class="ft-clock"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left mt-2">
                            <div class="form-control-position">
                                <i class="ft-dollar-sign"></i>
                            </div>
                            <input *ngIf="!task_model.budget" type="text" formControlName="budget" [(ngModel)]="budget_val" class="form-control"
                                placeholder="Enter budget">
                            <input *ngIf="task_model.budget" type="text" formControlName="budget" [(ngModel)]="task_model.budget"
                                class="form-control" placeholder="Enter budget">
                            <div class="form-control-position control-position-right">
                                <i class="ft-dollar-sign"></i>
                            </div>
                        </fieldset>
                    </div>
                </form>

            </div>
        </div>
        <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
            <button *ngIf="!isAddNewTask" type="button" class="btn btn-primary" (click)="createTask(formRef)">Create</button>
            <button *ngIf="isAddNewTask" type="button" class="btn btn-primary" (click)="submit()">Update</button>

        </div>
    </ng-template>
</div>

<!----- Add Demo Task Popup ----------->
<div>
    <ng-template #demoTask_modal let-modal>
        <div class="modal-header">
            <h3>Create Demo</h3>
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="modal-body taskboard-modal">
                <form [formGroup]="myForm">
                    <div class="container">
                        <div class="d-flex icons-list">
                            <div class="dropdown mr-2">
                                <i class="fa-solid fa-user-tie fa-xl cursor-pointer" placement="top"
                                    [ngClass]="{'active-icon': isEmpList }" [ngbTooltip]="task_for_selected"
                                    id="dropdownMenuButton" data-toggle="dropdown"
                                    (click)="isDropdownOpen = !isDropdownOpen; isEmpList = !isEmpList"></i>

                                <!-- <div class="dropdown-menu" [class.show]="isDropdownOpen" aria-labelledby="dropdownMenuButton">
                    <span class="dropdown-item"  (click)="toggleActiveStudent('student'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Student</span>
                    </span>
                    <span class="dropdown-item" (click)="toggleActiveStudent('emp'); isDropdownOpen = false">
                      <span class="active-tab cursor-pointer">Employee</span>
                    </span>
                  </div> -->
                            </div>
                            <div class="dropdown mr-1">
                                <i class="fa-solid fa-user-graduate fa-xl cursor-pointer" placement="top"
                                    [ngClass]="{'active-icon': isStudentList }" id="dropdownMenuButton-demo"
                                    data-toggle="dropdown"
                                    (click)="isDropdownOpen = !isDropdownOpen ; isStudentList = !isStudentList"></i>
                                <!-- <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isStudentList}" placement="top" ngbTooltip="individual" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isStudentList && !isBatchList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <i class="fas fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isBatchList}" placement="top" ngbTooltip="batch" id="dropdownMenuButton2" data-toggle="dropdown" *ngIf="isBatchList && !isStudentList && isStudent && !isEmployee"
                (click)="isDropdownOpen_student = !isDropdownOpen_student"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" *ngIf="isStudent" [class.show]="isDropdownOpen_student">
                  <a class="dropdown-item" *ngIf="!isStudentList" (click)="toggleActive('student-ind'); isDropdownOpen_student = false">Individual</a>
                  <a class="dropdown-item" *ngIf="!isBatchList" (click)="toggleActive('student-batch') ; isDropdownOpen_student = false">Batch</a>
                </div> -->
                            </div>
                            <!-- <div class="dropdown mr-2">
                <i class="fa-solid fa-user fa-xl cursor-pointer" [ngClass]="{'active-icon': isEmpList}" placement="top" ngbTooltip="individual"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isEmpList && !isTeamList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <i class="fa-solid fa-users fa-xl cursor-pointer" [ngClass]="{'active-icon': isTeamList}" placement="top" ngbTooltip="team"  id="dropdownMenuButton3" data-toggle="dropdown" *ngIf="isTeamList && !isEmpList && !isStudentList && !isStudent && isEmployee"
                (click)="isDropdownOpen_employee = !isDropdownOpen_employee"></i>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3" *ngIf="isEmployee" [class.show]="isDropdownOpen_employee">
                  <a class="dropdown-item" *ngIf="!isEmpList" (click)="toggleActive('emp-ind')">Individual</a>
                  <a class="dropdown-item" *ngIf="!isTeamList" (click)="toggleActive('emp-team')">Team</a>
                </div>
              </div> -->
                            <!-- <div class="dropdown mr-2" >
                <span class="icon mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isScheduleList || selectedSchedule}" (click)="isScheduleList = !isScheduleList" placement="top" ngbTooltip="schedule" id="scheduleList" data-toggle="dropdown" ><i class="fa-solid fa-calendar-days fa-xl"></i></span>
                <div class="dropdown-menu hide-scroll" aria-labelledby="scheduleList">
                  <a class="dropdown-item" *ngFor="let item of scheduleList" [class.active]="item.id === selectedSchedule">
                    <span (click)="getChangeScheduleId(item.id)">{{item.name}}</span>
                  </a>
                </div>
              </div>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isPriorityList || selected_task_priority}" (click)="isPriorityList = !isPriorityList" placement="top" ngbTooltip="priority" id="priorityList" data-toggle="dropdown"><i class="fa-solid fa-layer-group fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="priorityList">
                  <a class="dropdown-item" *ngFor="let item of task_priority_List" [class.active]="item._id === selected_task_priority">
                    <span (click)="getChangeTaskPriority(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div>
              <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': selectedType}" (click)="isType = !isType" placement="top" ngbTooltip="Type"><i class="ft-grid fa-xl"></i></span>
              <div class="dropdown">
                <span class="mr-2 mb-2 cursor-pointer" [ngClass]="{'active-icon': isTaskLabel || selectedTaskLabel}" (click)="isTaskLabel = !isTaskLabel" placement="top" ngbTooltip="task label" id="task_labelList" data-toggle="dropdown"><i class="ft-tag fa-xl"></i></span>
                <div class="dropdown-menu" aria-labelledby="task_labelList">
                  <a class="dropdown-item" *ngFor="let item of taskLabelList" [class.active]="item._id === selectedTaskLabel">
                    <span (click)="getChangeTaskLabelId(item._id)">{{item.displayname}}</span>
                  </a>
                </div>
              </div> -->
                            <div class="dropdown">
                                <span class="mr-2 mb-2 cursor-pointer"
                                    [ngClass]="{'active-icon-danger': isMandatory || selectedMandatory}"
                                    (click)="isMandatory = !isMandatory" placement="top" ngbTooltip="mandatory"
                                    id="mandatoryList" data-toggle="dropdown"><i
                                        class="ft-alert-circle fa-xl"></i></span>
                                <div class="dropdown-menu" aria-labelledby="mandatoryList">
                                    <a class="dropdown-item" *ngFor="let item of mandatoryList"
                                        [class.active]="item.id === selectedMandatory">
                                        <span (click)="getChangeMandatoryId(item.id)">{{item.name}}</span>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isEmpList || isTeamList ">
                            <ng-select *ngIf="!isTeam_selected_list" [items]="empList" bindLabel="name" bindValue="_id"
                                placeholder="Select Employee" [(ngModel)]="selectedEmp" [multiple]="true"
                                [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                                (open)="onDropdownOpenEmp($event)" (close)="onDropdownCloseEmp($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionEmp()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}" (change)="toggleSelectionEmp(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <ng-select *ngIf="isTeam_selected_list" [items]="team_selected_list" bindLabel="name"
                                bindValue="_id" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="team_selected_list_data" [ngModelOptions]="{ standalone: true }">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeamList ">
                            <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id"
                                placeholder="Select Team" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="selectTeam" [ngModelOptions]="{ standalone: true }"
                                (open)="onDropdownOpenTeam($event)" (close)="onDropdownCloseTeam($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionTeam()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}" (change)="toggleSelectionTeam(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </fieldset>
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTeam_selected_list">
            <ng-select *ngIf="isTeam_selected_list"
              [items]="team_selected_list"
              bindLabel="name"
              bindValue="_id"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="team_selected_list_data"
              [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
          </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isStudentList || isBatchList && !isEmployee">
                            <ng-select *ngIf="!isBatch_selected_list" [items]="studentList" bindLabel="name"
                                bindValue="id" placeholder="Select Student" [(ngModel)]="selectedStudent"
                                [multiple]="true" [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                                (open)="onDropdownOpenStudent($event)" (close)="onDropdownCloseStudent($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionStudent()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}"
                                            (change)="toggleSelectionStudent(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items">
                                    <div class="selected-items">
                                        <ng-container *ngFor="let item of items; let i = index">
                                            <div *ngIf="i < 5" class="chip">{{ item.name }}</div>
                                        </ng-container>
                                        <div *ngIf="items.length > 5" class="chip">+{{ items.length - 5 }} more</div>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <ng-select *ngIf="isBatch_selected_list" [items]="batch_selected_list" bindLabel="name"
                                bindValue="_id" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="batch_selected_list_data" [ngModelOptions]="{ standalone: true }">
                            </ng-select>

                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatchList && !isEmployee">
                            <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                                [(ngModel)]="selectedBatch" [multiple]="true" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenBatch($event)"
                                (close)="onDropdownCloseBatch($event)">
                                <ng-template ng-header-tmp>
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="isAllSelected"
                                            [ngModelOptions]="{standalone: true}" (click)="toggleAllSelectionBatch()">
                                        <span>Select All</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="checkbox-container">
                                        <input type="checkbox" [(ngModel)]="item.selected"
                                            [ngModelOptions]="{standalone: true}" (change)="toggleSelectionBatch(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>

                        </fieldset>
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isBatch_selected_list">
          <ng-select
            [items]="batch_selected_list"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="batch_selected_list_data"
            [ngModelOptions]="{ standalone: true }"
          >
        </ng-select>
        </fieldset> -->
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isScheduleList">
          <ng-select
                [items]="scheduleList"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Schedule"
                [(ngModel)]="selectedSchedule"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeScheduleId($event)"
              >
          </ng-select>
          
        </fieldset> -->
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isPriorityList">
          <ng-select
            [items]="task_priority_List"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Priority"
            [(ngModel)]="selected_task_priority"
            [ngModelOptions]="{ standalone: true }"
            (change)="getChangeTaskPriority($event)"
          >
          </ng-select>
          
        </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left" *ngIf="isType">
                            <ng-select [items]="typeList" bindLabel="name" bindValue="id" placeholder="Select Type"
                                [(ngModel)]="selectedType" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (change)="getChangeTypeId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isProjectList && !isCheckList && !isLeadType">
                            <ng-select [items]="project_list" bindLabel="name" bindValue="_id"
                                placeholder="Select Project" [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="select_project" [ngModelOptions]="{ standalone: true }"
                                (change)="getProjectId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isCheckList && !isProjectList && !isLeadType">
                            <ng-select [items]="check_list" bindLabel="name" bindValue="_id" placeholder="Select check"
                                [multiple]="true" [closeOnSelect]="false" [(ngModel)]="select_checklist"
                                [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isLeadType && !isCheckList && !isProjectList">
                            <ng-select [items]="leads_type" bindLabel="name" bindValue="id" placeholder="Select Lead"
                                [(ngModel)]="select_leadType" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (change)="getLeadTypeId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isTrainingLead && !isOutsourceLead && !isCheckList && !isProjectList">
                            <ng-select [items]="training_list" bindLabel="title" bindValue="_id"
                                placeholder="Select Training" [(ngModel)]="select_training_lead" [closeOnSelect]="false"
                                [ngModelOptions]="{ standalone: true }" (change)="getTrainingLeadId($event)">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left"
                            *ngIf="isOutsourceLead && !isTrainingLead && !isCheckList && !isProjectList">
                            <ng-select [items]="outsource_list" bindLabel="leads.title" bindValue="_id"
                                placeholder="Select Outsource" [(ngModel)]="select_outsource_lead"
                                [closeOnSelect]="false" [ngModelOptions]="{ standalone: true }"
                                (change)="getOutsourceLeadId($event)">
                            </ng-select>
                        </fieldset>
                        <!-- <fieldset class="form-group position-relative has-icon-left" *ngIf="isTaskLabel">
          <ng-select
                [items]="taskLabelList"
                bindLabel="displayname"
                bindValue="_id"
                placeholder="Select TaskLabel"
                [(ngModel)]="selectedTaskLabel"
                [closeOnSelect]="false"
                [ngModelOptions]="{ standalone: true }"
                (change)="getChangeTaskLabelId($event)"
              >
          </ng-select>
          
        </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left">
                            <div class="form-control-position">
                                <i class="ft-edit-2"></i>
                            </div>
                            <input type="text" formControlName="title" class="form-control" id="todoTitle"
                                placeholder="Title" (keydown.enter)="$event.preventDefault()" required #todoTitle>
                            <div class="form-control-position control-position-right">
                                <i class="ft-edit-2"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left">
                            <div class="form-control-position">
                                <i class="ft-message-square"></i>
                            </div>
                            <textarea formControlName="body" class="form-control" placeholder="body">
              <div class="form-control-position control-position-right">
                <i class="ft-message-square"></i>
              </div>
            </textarea>
                        </fieldset>
                        <!-- <fieldset *ngIf="isMandatory">
              <ng-select
              [items]="mandatoryList"
              bindLabel="name"
              bindValue="id"
              placeholder="Select Mandatory"
              [(ngModel)]="selectedMandatory"
              [closeOnSelect]="false"
              [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>
            </fieldset> -->
                        <fieldset class="form-group position-relative has-icon-left mt-2">
                            <div class="form-control-position">
                                <i class="fa-regular fa-calendar-days"></i>
                            </div>
                            <input type="date" formControlName="due_date" [(ngModel)]="current_date"
                                class="form-control">
                            <div class="form-control-position control-position-right">
                                <i class="fa-regular fa-calendar-days"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left mt-2">
                            <div class="form-control-position">
                                <i class="ft-clock"></i>
                            </div>
                            <input type="text" formControlName="time" [(ngModel)]="time" class="form-control">
                            <div class="form-control-position control-position-right">
                                <i class="ft-clock"></i>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left mt-2">
                            <div class="form-control-position">
                                <i class="ft-dollar-sign"></i>
                            </div>
                            <input type="text" formControlName="budget" [(ngModel)]="budget_val" class="form-control"
                                placeholder="Enter budget">
                            <div class="form-control-position control-position-right">
                                <i class="ft-dollar-sign"></i>
                            </div>
                        </fieldset>
                    </div>
                </form>

            </div>
        </div>
        <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
            <button *ngIf="isAddNewTask" type="button" class="btn btn-primary" (click)="createTask()">Create</button>

        </div>
    </ng-template>
</div>


<!----- Admin Notes / Guideline Update Popup -->

<div class=" modal-Admin-Notes">
    <ng-template #adminNotesModal let-modal>
        <div class=" modal-Admin-Notes">
            <div class="modal-header">
                <h4 class="modal-title">Guidelines</h4>
                <button type="button" class="close" (click)="modal.dismiss()">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div>
                    <div class="d-flex">
                        <span class="current-task-box" *ngIf="!isEditor && update_row_data"
                            [innerHtml]="update_row_data"></span>
                        <span *ngIf="!update_row_data  ">
                            <i (click)="isEditor =!isEditor" class="ft-plus text-primary cursor-pointer"
                                placement="right" ngbTooltip="add new"></i>
                        </span>
                        <span class="ml-2" *ngIf="update_row_data"> <i (click)="isEditor =!isEditor"
                                class="ft-edit text-primary cursor-pointer"></i> </span>
                    </div>
                    <div *ngIf="isEditor">
                        <quill-editor (onEditorCreated)="setFocus($event)"
                            (onContentChanged)="inlineEditing(update_row_data)"
                            [(ngModel)]="update_row_data"></quill-editor>
                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitEditData()">Submit</button>
            </div>
        </div>
    </ng-template>
</div>

<!-------- Update Task Body Or Notes -->

<div>
    <ng-template #myModal3 let-modal>
        <div class="modal-header">
            <h4 class="modal-title" *ngIf="isReadOnly">Add</h4>
            <h4 class="modal-title" *ngIf="!isReadOnly">Update</h4>

            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="text-editor">
                <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="inlineEditing(update_row_data)"
                    [(ngModel)]="update_row_data"></quill-editor>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="submitEditData()">Submit</button>
        </div>
    </ng-template>
</div>
